export const settings_pricing_plan_en = {
  frequently_asked_questions: "Frequently Asked Questions",
  credit_usage_intro:
    "Every action draws from your credit balance — here's what each one costs.",
  credits_count: "{n} credit | {n} credits",
  why_add_credit_card_question:
    "Why do I need to add my credit card to test the tool?",
  why_add_credit_card_answer:
    "Adding a credit card helps us verify you're a real person and prevents spam. You won't be charged. Since we rely on third-party email finder tools, free credits still cost us money. This quick verification step keeps the platform secure, supports real users, and helps us keep prices low.",
  if_charged_free_trial_question: "Will I be charged for the free trial?",
  if_charged_free_trial_answer:
    "No, adding your credit card is for verification only. You won't be charged unless you choose to upgrade later.",

  what_happens_after_add_card_question: "What happens after I add my card?",
  what_happens_after_add_card_answer:
    "After your first top-up, you will instantly receive additional free credits to test the tool, no matter how much - no strings attached!",

  features: "Features",
  search: "Search",
  per_page_limits: "Per page limits",
  total_page_limits: "Total page limits",
  record_upload_limits: "Record upload limits",
  export_limits: "Export limits",
  top_up_credits: "Top-up credits",
  record_selections: "Record selections",
  company_selection_limit: "Company Selection Limit",
  prospect_selection_limit: "Prospect Selection Limit",
  portal: "Portal",
  query_limit_per_hour: "Query Limit Per Hour",
  query_limit_per_day: "Query Limit Per Day",
  query_limit_per_month: "Query Limit Per Month",
  api: "API",
  call_limit_per_hour: "Call Limit Per Hour",
  call_limit_per_day: "Call Limit Per Day",
  call_limit_per_month: "Call Limit Per Month",
  pricing_plan_compare_all_plans: "Compare all plans",
  pricing_plan_title: "Pricing Plans",
  pricing_plan_desc: "Choose the plan that fits your needs. No hidden fees.",
  save_20: "Save 20%",
  pricing_plan_currency_list: "Currency list",
  most_popular: "Most popular",
  per_monthly: "month",
  per_annual: "annual",
  by_monthly: "monthly",
  by_annual: "annually",
  pricing_plan_per_cost: "Per user, per month — Billed {type}",
  pricing_plan_organization_desc:
    "Our Custom Plan offers flexible solutions and credits that suit your exact needs.",
  pricing_plan_credit_info:
    "Credits are our currency and are consumed when you perform certain actions on the platform.",
  exports: "Exports",
  get_in_touch: "Get in Touch",
  get_in_touch_desc:
    "Contact us today to discuss your needs and get a personalized quote",
  pricing_plan_learn_credits: "Learn more about credits",
  pricing_plans_primary_button_current: "Current plan",
  pricing_plans_primary_button_free: "Start free trial",
  pricing_plans_primary_button: "Get started",
  pricing_plans_primary_button_organization: "Contact us",

  free_feature_1: "300M+ prospects & company records",
  free_feature_2: "Verified emails & phone numbers",
  free_feature_3: "Expansion signals — last 90 days",

  startup_feature_1: "Everything in Free",
  startup_feature_2: "Full expansion history & every signal",
  startup_feature_3: "In-market teams & all markets",
  startup_feature_4: "API access & automation",

  corporate_feature_1: "Everything in Startup",
  corporate_feature_2: "Analytics & pre-built reports",
  corporate_feature_3: "Team & quota management",
  corporate_feature_4: "Advanced security & SSO",
  corporate_feature_5: "Priority support",

  organization_feature_1: "Everything in Corporate",
  organization_feature_2: "Custom limits & credits",
  organization_feature_3: "Dedicated success manager",
  organization_feature_4: "Custom integrations & SSO",
  organization_feature_5: "SLA & onboarding",

  plan_tagline_free: "For getting started",
  plan_tagline_startup: "For growing sales teams",
  plan_tagline_corporate: "For scaling sales orgs",
  plan_tagline_organization: "For enterprises",

  pricing_plan_whats_included: "What's included",
  pricing_plan_credits_line: "{n} credits / month",

  pricing_section_usage: "Usage & limits",
  pricing_section_portal: "Portal queries",
  pricing_section_api: "API",
  pricing_section_access: "Access & security",
  api_access: "API access",

  pricing_section_expansion: "Expansion intelligence",
  expansion_signal_history: "Signal history",
  expansion_signals_team: "Every signal & in-market team",
  expansion_employees: "Employee data (headcount & people)",
  expansion_markets: "Expansion markets",
  expansion_full: "Full",
  expansion_n_days: "{n} days",
  expansion_all: "All",

  sequence_execution: "Sequence Execution",
  sequence_execution_details:
    "Each action performed consumes 0 credits.| Each action performed consumes 1 credit. |Each action performed consumes {0} credits.",
  ai_translation: "AI Translation",
  ai_translation_details:
    "Each AI translation result consumes 0 credits. | Each AI translation result consumes 1 credit. | Each AI translation result consumes {0} credits.",

  includes: "includes",

  pricing_plans_customize_feature_title: "Personalized Plan",
  pricing_plans_customize_feature_desc:
    "Our customized subscription service is designed to help organizations support business growth",

  settings_estimate_subscription: "Subscription:",
  settings_estimate_original_price: "Original Price:",

  permission_profiles: "Permission Profiles",
  team_management: "Team Management",
};

// Simplified Chinese
export const settings_pricing_plan_zhHans = {
  frequently_asked_questions: "常见问题",
  credit_usage_intro: "每个操作都会消耗账户额度，以下是每项操作的费用。",
  credits_count: "{n} 额度 | {n} 额度",
  why_add_credit_card_question: "为什么需要添加信用卡？",
  why_add_credit_card_answer:
    "添加信用卡有助于我们验证您是真实用户，防止垃圾信息，而且您不会被收费。由于我们依赖第三方邮箱查找工具，免费额度实际上也会产生费用。这个快速的验证步骤可以保持平台安全，支持真实用户，并帮助我们维持低价。",
  if_charged_free_trial_question: "免费试用会收费吗？",
  if_charged_free_trial_answer: "不会，仅用于验证，除非升级不会收费。",
  what_happens_after_add_card_question: "添加后会怎样？",
  what_happens_after_add_card_answer:
    "首次充值后，您将立即获得额外的免费积分用于测试工具，无论金额多少——完全无附加条件！",
  features: "功能",
  search: "搜索",
  per_page_limits: "每页限制",
  total_page_limits: "总页数限制",
  record_upload_limits: "上传记录限制",
  export_limits: "导出限制",
  top_up_credits: "充值额度",
  record_selections: "记录选择",
  company_selection_limit: "公司选择上限",
  prospect_selection_limit: "潜在客户选择上限",
  portal: "平台",
  query_limit_per_hour: "每小时查询上限",
  query_limit_per_day: "每日查询上限",
  query_limit_per_month: "每月查询上限",
  api: "API",
  call_limit_per_hour: "每小时调用上限",
  call_limit_per_day: "每日调用上限",
  call_limit_per_month: "每月调用上限",
  pricing_plan_compare_all_plans: "比较所有方案",
  pricing_plan_title: "定价方案",
  pricing_plan_desc: "选择适合你的方案，无隐藏费用。",
  save_20: "节省 20%",
  pricing_plan_currency_list: "货币列表",
  most_popular: "最受欢迎",
  per_monthly: "月",
  per_annual: "年",
  by_monthly: "按月",
  by_annual: "按年",
  pricing_plan_per_cost: "每用户每月 - {type}计费",
  pricing_plan_organization_desc: "定制方案提供灵活额度和功能，满足您的需求。",
  pricing_plan_credit_info: "积分为平台通用单位，用于执行特定操作时消耗。",
  exports: "导出",
  get_in_touch: "联系我们",
  get_in_touch_desc: "欢迎联系我们，获取个性化报价",
  pricing_plan_learn_credits: "了解更多信用点数详情",
  pricing_plans_primary_button_current: "当前方案",
  pricing_plans_primary_button_free: "开始免费试用",
  pricing_plans_primary_button: "立即开始",
  pricing_plans_primary_button_organization: "联系我们",

  free_feature_1: "300M+ 潜在客户和公司记录",
  free_feature_2: "已验证的邮箱和电话号码",
  free_feature_3: "扩张信号 — 最近 90 天",

  startup_feature_1: "包含免费版全部功能",
  startup_feature_2: "完整扩张历史与全部信号",
  startup_feature_3: "本地团队与全部市场",
  startup_feature_4: "API 访问与自动化",

  corporate_feature_1: "包含 Startup 全部功能",
  corporate_feature_2: "分析与预构建报告",
  corporate_feature_3: "团队与配额管理",
  corporate_feature_4: "高级安全与 SSO",
  corporate_feature_5: "优先支持",

  organization_feature_1: "包含 Corporate 全部功能",
  organization_feature_2: "定制额度与积分",
  organization_feature_3: "专属客户成功经理",
  organization_feature_4: "定制集成与 SSO",
  organization_feature_5: "SLA 与上线支持",

  plan_tagline_free: "适合入门",
  plan_tagline_startup: "适合成长中的销售团队",
  plan_tagline_corporate: "适合规模化的销售组织",
  plan_tagline_organization: "适合企业",

  pricing_plan_whats_included: "包含内容",
  pricing_plan_credits_line: "{n} 积分 / 月",

  pricing_section_usage: "使用与限制",
  pricing_section_portal: "门户查询",
  pricing_section_api: "API",
  pricing_section_access: "访问与安全",
  api_access: "API 访问",

  pricing_section_expansion: "扩张情报",
  expansion_signal_history: "信号历史",
  expansion_signals_team: "全部信号与本地团队",
  expansion_employees: "员工数据（人数与人员）",
  expansion_markets: "扩张市场",
  expansion_full: "完整",
  expansion_n_days: "{n} 天",
  expansion_all: "全部",

  sequence_execution: "工作流程执行",
  sequence_execution_details:
    "每个执行的操作将消耗 0 个积分。| 每个执行的操作将消耗 1 个积分。| 每个执行的操作将消耗 {0} 个积分。",
  ai_translation: "AI 翻译",
  ai_translation_details:
    "每次 AI 翻译结果将消耗 0 个积分。| 每次 AI 翻译结果将消耗 1 个积分。| 每次 AI 翻译结果将消耗 {0} 个积分。",
  includes: "包含",

  pricing_plans_customize_feature_title: "个性化方案",
  pricing_plans_customize_feature_desc:
    "我们的定制订阅服务旨在帮助组织支持业务增长",

  settings_estimate_subscription: "订阅费用:",
  settings_estimate_original_price: "原价:",

  permission_profiles: "权限配置文件",
  team_management: "团队管理",
};

// Traditional Chinese
export const settings_pricing_plan_zhHant = {
  frequently_asked_questions: "常見問題",
  credit_usage_intro: "每個操作都會消耗帳戶額度，以下是每項操作的費用。",
  credits_count: "{n} 額度 | {n} 額度",
  why_add_credit_card_question: "為什麼需要新增信用卡來測試工具？",
  why_add_credit_card_answer:
    "添加信用卡有助於我們驗證您是真實用戶，防止垃圾訊息，而且您不會被收費。由於我們依賴第三方電郵搜尋工具，免費額度實際上亦會產生費用。這個快速的驗證步驟可以保持平台安全，支持真實用戶，並幫助我們維持低價。",
  if_charged_free_trial_question: "免費試用會收費嗎？",
  if_charged_free_trial_answer:
    "不會，新增信用卡僅作為驗證，除非您選擇升級，否則不會產生費用。",
  what_happens_after_add_card_question: "新增信用卡後會發生什麼？",
  what_happens_after_add_card_answer:
    "首次充值後，您將即時獲得額外的免費積分用於測試工具，無論金額多少——完全無附加條件！",
  features: "功能",
  search: "搜尋",
  per_page_limits: "每頁限制",
  total_page_limits: "總頁數限制",
  record_upload_limits: "上傳記錄限制",
  export_limits: "匯出限制",
  top_up_credits: "充值信用點數",
  record_selections: "記錄選取",
  company_selection_limit: "公司選取上限",
  prospect_selection_limit: "潛在客戶選取上限",
  portal: "平台",
  query_limit_per_hour: "每小時查詢上限",
  query_limit_per_day: "每日查詢上限",
  query_limit_per_month: "每月查詢上限",
  api: "API",
  call_limit_per_hour: "每小時呼叫上限",
  call_limit_per_day: "每日呼叫上限",
  call_limit_per_month: "每月呼叫上限",
  pricing_plan_compare_all_plans: "比較所有方案",
  pricing_plan_title: "方案價格",
  pricing_plan_desc: "選擇最適合您的方案，無任何隱藏費用。",
  save_20: "省下 20%",
  pricing_plan_currency_list: "貨幣列表",
  most_popular: "最受歡迎",
  per_monthly: "月",
  per_annual: "年",
  by_monthly: "按月計費",
  by_annual: "按年計費",
  pricing_plan_per_cost: "每位用戶每月 - {type}",
  pricing_plan_organization_desc:
    "客製方案提供彈性功能與信用點數，完全依您需求設計。",
  pricing_plan_credit_info: "信用點數是平台的通用貨幣，執行特定操作時會消耗。",
  exports: "匯出",
  get_in_touch: "聯絡我們",
  get_in_touch_desc: "歡迎與我們聯繫，獲取專屬報價與協助",
  pricing_plan_learn_credits: "了解更多信用點數資訊",
  pricing_plans_primary_button_current: "目前方案",
  pricing_plans_primary_button_free: "開始免費試用",
  pricing_plans_primary_button: "立即開始",
  pricing_plans_primary_button_organization: "聯絡我們",

  free_feature_1: "300M+ 潛在客戶和公司記錄",
  free_feature_2: "已驗證的郵箱和電話號碼",
  free_feature_3: "擴張訊號 — 最近 90 天",

  startup_feature_1: "包含免費版全部功能",
  startup_feature_2: "完整擴張歷史與全部訊號",
  startup_feature_3: "本地團隊與全部市場",
  startup_feature_4: "API 存取與自動化",

  corporate_feature_1: "包含 Startup 全部功能",
  corporate_feature_2: "分析與預構建報告",
  corporate_feature_3: "團隊與配額管理",
  corporate_feature_4: "進階安全與 SSO",
  corporate_feature_5: "優先支援",

  organization_feature_1: "包含 Corporate 全部功能",
  organization_feature_2: "客製額度與點數",
  organization_feature_3: "專屬客戶成功經理",
  organization_feature_4: "客製整合與 SSO",
  organization_feature_5: "SLA 與上線支援",

  plan_tagline_free: "適合入門",
  plan_tagline_startup: "適合成長中的銷售團隊",
  plan_tagline_corporate: "適合規模化的銷售組織",
  plan_tagline_organization: "適合企業",

  pricing_plan_whats_included: "包含內容",
  pricing_plan_credits_line: "{n} 點數 / 月",

  pricing_section_usage: "使用與限制",
  pricing_section_portal: "入口查詢",
  pricing_section_api: "API",
  pricing_section_access: "存取與安全",
  api_access: "API 存取",

  pricing_section_expansion: "擴張情報",
  expansion_signal_history: "訊號歷史",
  expansion_signals_team: "全部訊號與本地團隊",
  expansion_employees: "員工資料（人數與人員）",
  expansion_markets: "擴張市場",
  expansion_full: "完整",
  expansion_n_days: "{n} 天",
  expansion_all: "全部",

  sequence_execution: "工作流程執行",
  sequence_execution_details:
    "每個執行的操作將消耗 0 點額度。| 每個執行的操作將消耗 1 點額度。| 每個執行的操作將消耗 {0} 點額度。",
  ai_translation: "AI 翻譯",
  ai_translation_details:
    "每次 AI 翻譯結果將消耗 0 點額度。| 每次 AI 翻譯結果將消耗 1 點額度。| 每次 AI 翻譯結果將消耗 {0} 點額度。",

  includes: "包含",
  pricing_plans_customize_feature_title: "個人化方案",
  pricing_plans_customize_feature_desc:
    "我們的客製化訂閱服務旨在協助組織推動業務成長",

  settings_estimate_subscription: "訂閱費用:",
  settings_estimate_original_price: "原價:",

  permission_profiles: "權限配置檔",
  team_management: "團隊管理",
};

// Japanese
export const settings_pricing_plan_ja = {
  frequently_asked_questions: "よくある質問",
  credit_usage_intro:
    "各アクションはクレジット残高から消費されます。各アクションのコストは以下のとおりです。",
  credits_count: "{n} クレジット | {n} クレジット",
  why_add_credit_card_question:
    "なぜツールを試すのにクレジットカードが必要ですか？",
  why_add_credit_card_answer:
    "クレジットカードの登録は、本物のユーザーであることを確認し、スパムを防止するためです。課金されることはありません。当社はサードパーティのメール検索ツールを使用しており、無料枠にも実際にはコストがかかります。この簡単な認証ステップにより、プラットフォームの安全性が保たれ、本物のユーザーをサポートし、低価格を維持できます。",
  if_charged_free_trial_question: "無料トライアルで課金されますか？",
  if_charged_free_trial_answer:
    "いいえ、クレジットカードの登録は認証のみを目的としており、アップグレードを選択しない限り課金されることはありません。",
  what_happens_after_add_card_question:
    "クレジットカードを登録するとどうなりますか？",
  what_happens_after_add_card_answer:
    "最初のチャージ後、金額に関係なく追加の無料クレジットが即時付与され、ツールをテストできます - 一切の条件なしです！",

  features: "機能",
  search: "検索",
  per_page_limits: "ページあたりの制限",
  total_page_limits: "総ページ制限",
  record_upload_limits: "レコードアップロード制限",
  export_limits: "エクスポート制限",
  top_up_credits: "クレジットチャージ",
  record_selections: "レコード選択",
  company_selection_limit: "会社選択上限",
  prospect_selection_limit: "見込み客選択上限",
  portal: "プラットフォーム",
  query_limit_per_hour: "1時間あたりのクエリ上限",
  query_limit_per_day: "1日あたりのクエリ上限",
  query_limit_per_month: "1ヶ月あたりのクエリ上限",
  api: "API",
  call_limit_per_hour: "1時間あたりのコール上限",
  call_limit_per_day: "1日あたりのコール上限",
  call_limit_per_month: "1ヶ月あたりのコール上限",

  pricing_plan_compare_all_plans: "全プランを比較",
  pricing_plan_title: "プラン料金",
  pricing_plan_desc:
    "隠れた費用なしで、あなたに最適なプランを選択してください。",
  save_20: "20%節約",
  pricing_plan_currency_list: "通貨リスト",
  most_popular: "人気プラン",
  per_monthly: "月額",
  per_annual: "年額",
  by_monthly: "月払い",
  by_annual: "年払い",
  pricing_plan_per_cost: "ユーザーあたり月額 - {type}",
  pricing_plan_organization_desc:
    "カスタムプランは、あなたのニーズに完全に合わせた柔軟な機能とクレジットを提供します。",
  pricing_plan_credit_info:
    "クレジットはプラットフォームの共通通貨で、特定の操作を実行すると消費されます。",

  exports: "エクスポート",
  get_in_touch: "お問い合わせ",
  get_in_touch_desc:
    "カスタム見積もりとサポートについてはお気軽にご連絡ください",
  pricing_plan_learn_credits: "クレジットの詳細",
  pricing_plans_primary_button_current: "現在のプラン",
  pricing_plans_primary_button_free: "無料トライアルを開始",
  pricing_plans_primary_button: "今すぐ開始",
  pricing_plans_primary_button_organization: "お問い合わせ",

  free_feature_1: "300M+ の見込み客と会社データ",
  free_feature_2: "検証済みのメールと電話番号",
  free_feature_3: "拡大シグナル — 直近90日",

  startup_feature_1: "無料プランのすべてを含む",
  startup_feature_2: "拡大の全履歴とすべてのシグナル",
  startup_feature_3: "現地チームと全市場",
  startup_feature_4: "APIアクセスと自動化",

  corporate_feature_1: "Startup のすべてを含む",
  corporate_feature_2: "分析と事前構築レポート",
  corporate_feature_3: "チームとクォータ管理",
  corporate_feature_4: "高度なセキュリティと SSO",
  corporate_feature_5: "優先サポート",

  organization_feature_1: "Corporate のすべてを含む",
  organization_feature_2: "カスタムの上限とクレジット",
  organization_feature_3: "専任カスタマーサクセス担当",
  organization_feature_4: "カスタム統合と SSO",
  organization_feature_5: "SLA とオンボーディング",

  plan_tagline_free: "まず試してみたい方に",
  plan_tagline_startup: "成長中の営業チームに",
  plan_tagline_corporate: "規模化する営業組織に",
  plan_tagline_organization: "エンタープライズに",

  pricing_plan_whats_included: "含まれる内容",
  pricing_plan_credits_line: "{n} クレジット / 月",

  pricing_section_usage: "利用と上限",
  pricing_section_portal: "ポータルクエリ",
  pricing_section_api: "API",
  pricing_section_access: "アクセスとセキュリティ",
  api_access: "APIアクセス",

  pricing_section_expansion: "拡大インテリジェンス",
  expansion_signal_history: "シグナル履歴",
  expansion_signals_team: "すべてのシグナルと現地チーム",
  expansion_employees: "従業員データ（人数と担当者）",
  expansion_markets: "拡大市場",
  expansion_full: "全期間",
  expansion_n_days: "{n}日",
  expansion_all: "すべて",

  free_feature_title: "無料プランに含まれるもの",
  growth_feature_title: "スタートアッププランに含まれるもの",
  business_feature_title: "ビジネスプランに含まれるもの",
  organization_feature_title: "カスタムプランに含まれるもの",

  sequence_execution: "ワークフロー実行",
  sequence_execution_details:
    "実行ごとに0クレジット消費します。| 実行ごとに1クレジット消費します。| 実行ごとに{0}クレジット消費します。",
  ai_translation: "AI翻訳",
  ai_translation_details:
    "AI翻訳ごとに0クレジット消費します。| AI翻訳ごとに1クレジット消費します。| AI翻訳ごとに{0}クレジット消費します。",

  includes: "含まれるもの",
  pricing_plans_customize_feature_title: "カスタマイズプラン",
  pricing_plans_customize_feature_desc:
    "当社のカスタムサブスクリプションサービスは、組織のビジネス成長を推進するために設計されています",

  settings_estimate_subscription: "サブスクリプション:",
  settings_estimate_original_price: "元の価格:",
  permission_profiles: "権限プロファイル",
  team_management: "チーム管理",
};

// Korean
export const settings_pricing_plan_ko = {
  frequently_asked_questions: "자주 묻는 질문",
  credit_usage_intro:
    "모든 작업은 크레딧 잔액에서 차감됩니다. 각 작업의 비용은 다음과 같습니다.",
  credits_count: "{n} 크레딧 | {n} 크레딧",
  why_add_credit_card_question:
    "도구를 테스트하기 위해 신용카드를 추가해야 하는 이유는 무엇인가요?",
  why_add_credit_card_answer:
    "신용카드 추가는 실제 사용자인지 확인하고 스팸을 방지하기 위한 것이며, 요금이 청구되지 않습니다. 당사는 제3자 이메일 검색 도구를 사용하고 있으며 무료 할당량에도 실제 비용이 발생합니다. 이 빠른 인증 단계는 플랫폼 보안을 유지하고 실제 사용자를 지원하며 저비용 유지에 도움이 됩니다.",
  if_charged_free_trial_question: "무료 체험판에서 요금이 청구되나요?",
  if_charged_free_trial_answer:
    "아니요, 신용카드 추가는 인증만을 위한 것이며 업그레이드를 선택하지 않는 한 요금이 청구되지 않습니다.",
  what_happens_after_add_card_question: "신용카드를 추가하면 어떻게 되나요?",
  what_happens_after_add_card_answer:
    "첫 충전 후 금액에 관계없이 추가 무료 크레딧이 즉시 제공되어 도구를 테스트할 수 있습니다 - 어떠한 조건도 없습니다!",

  features: "기능",
  search: "검색",
  per_page_limits: "페이지당 제한",
  total_page_limits: "총 페이지 제한",
  record_upload_limits: "레코드 업로드 제한",
  export_limits: "내보내기 제한",
  top_up_credits: "크레딧 충전",
  record_selections: "레코드 선택",
  company_selection_limit: "회사 선택 상한",
  prospect_selection_limit: "잠재 고객 선택 상한",
  portal: "플랫폼",
  query_limit_per_hour: "시간당 쿼리 상한",
  query_limit_per_day: "일일 쿼리 상한",
  query_limit_per_month: "월간 쿼리 상한",
  api: "API",
  call_limit_per_hour: "시간당 호출 상한",
  call_limit_per_day: "일일 호출 상한",
  call_limit_per_month: "월간 호출 상한",

  pricing_plan_compare_all_plans: "모든 플랜 비교",
  pricing_plan_title: "플랜 가격",
  pricing_plan_desc: "숨겨진 비용 없이 귀하에게 가장 적합한 플랜을 선택하세요.",
  save_20: "20% 절약",
  pricing_plan_currency_list: "통화 목록",
  most_popular: "인기 플랜",
  per_monthly: "월간",
  per_annual: "연간",
  by_monthly: "월별 결제",
  by_annual: "연간 결제",
  pricing_plan_per_cost: "사용자당 월 - {type}",
  pricing_plan_organization_desc:
    "맞춤형 플랜은 귀하의 필요에 완벽하게 맞춰진 유연한 기능과 크레딧을 제공합니다.",
  pricing_plan_credit_info:
    "크레딧은 플랫폼의 공통 통화로, 특정 작업을 실행할 때 소비됩니다.",

  exports: "내보내기",
  get_in_touch: "문의하기",
  get_in_touch_desc: "맞춤형 견적과 지원을 위해 저희에게 연락하세요",
  pricing_plan_learn_credits: "크레딧에 대해 더 알아보기",
  pricing_plans_primary_button_current: "현재 플랜",
  pricing_plans_primary_button_free: "무료 체험 시작",
  pricing_plans_primary_button: "지금 시작하기",
  pricing_plans_primary_button_organization: "문의하기",

  free_feature_1: "300M+ 잠재 고객 및 회사 기록",
  free_feature_2: "검증된 이메일 및 전화번호",
  free_feature_3: "확장 시그널 — 최근 90일",

  startup_feature_1: "무료 플랜의 모든 기능 포함",
  startup_feature_2: "전체 확장 기록 및 모든 시그널",
  startup_feature_3: "현지 팀 및 모든 시장",
  startup_feature_4: "API 액세스 및 자동화",

  corporate_feature_1: "Startup의 모든 기능 포함",
  corporate_feature_2: "분석 및 사전 구축 보고서",
  corporate_feature_3: "팀 및 할당량 관리",
  corporate_feature_4: "고급 보안 및 SSO",
  corporate_feature_5: "우선 지원",

  organization_feature_1: "Corporate의 모든 기능 포함",
  organization_feature_2: "맞춤 한도 및 크레딧",
  organization_feature_3: "전담 고객 성공 매니저",
  organization_feature_4: "맞춤 통합 및 SSO",
  organization_feature_5: "SLA 및 온보딩",

  plan_tagline_free: "시작하기에 적합",
  plan_tagline_startup: "성장하는 영업팀을 위해",
  plan_tagline_corporate: "확장하는 영업 조직을 위해",
  plan_tagline_organization: "엔터프라이즈를 위해",

  pricing_plan_whats_included: "포함 내용",
  pricing_plan_credits_line: "{n} 크레딧 / 월",

  pricing_section_usage: "사용량 및 한도",
  pricing_section_portal: "포털 쿼리",
  pricing_section_api: "API",
  pricing_section_access: "액세스 및 보안",
  api_access: "API 액세스",

  pricing_section_expansion: "확장 인텔리전스",
  expansion_signal_history: "시그널 기록",
  expansion_signals_team: "모든 시그널 및 현지 팀",
  expansion_employees: "직원 데이터(인원수 및 담당자)",
  expansion_markets: "확장 시장",
  expansion_full: "전체",
  expansion_n_days: "{n}일",
  expansion_all: "전체",

  free_feature_title: "무료 플랜 포함 사항",
  growth_feature_title: "스타터 플랜 포함 사항",
  business_feature_title: "비즈니스 플랜 포함 사항",
  organization_feature_title: "맞춤형 플랜 포함 사항",

  sequence_execution: "워크플로 실행",
  sequence_execution_details:
    "실행당 0크레딧 소모됩니다.| 실행당 1크레딧 소모됩니다.| 실행당 {0}크레딧 소모됩니다.",
  ai_translation: "AI 번역",
  ai_translation_details:
    "AI 번역당 0크레딧 소모됩니다.| AI 번역당 1크레딧 소모됩니다.| AI 번역당 {0}크레딧 소모됩니다.",

  includes: "포함 사항",
  pricing_plans_customize_feature_title: "맞춤형 플랜",
  pricing_plans_customize_feature_desc:
    "당사의 맞춤형 구독 서비스는 조직의 비즈니스 성장을 주도하도록 설계되었습니다",

  settings_estimate_subscription: "구독료:",
  settings_estimate_original_price: "원래 가격:",

  permission_profiles: "권한 프로필",
  team_management: "팀 관리",
};

// Hindi
export const settings_pricing_plan_hi = {
  frequently_asked_questions: "अक्सर पूछे जाने वाले प्रश्न",
  credit_usage_intro:
    "हर क्रिया आपके क्रेडिट बैलेंस से कटती है — यहाँ प्रत्येक की लागत दी गई है।",
  credits_count: "{n} क्रेडिट | {n} क्रेडिट",
  why_add_credit_card_question:
    "टूल टेस्ट करने के लिए क्रेडिट कार्ड क्यों जोड़ना होगा?",
  why_add_credit_card_answer:
    "क्रेडिट कार्ड जोड़ने से हमें वास्तविक उपयोगकर्ता सत्यापित करने में मदद मिलती है, स्पैम रोकता है, और आपसे कोई शुल्क नहीं लिया जाएगा। चूंकि हम तृतीय-पक्ष ईमेल खोज टूल्स पर निर्भर हैं, फ्री कोटा भी वास्तव में लागत उत्पन्न करता है। यह त्वरित सत्यापन चरण प्लेटफॉर्म सुरक्षित रखता है, वास्तविक उपयोगकर्ताओं को सपोर्ट करता है और हमें कम कीमत बनाए रखने में मदद करता है।",
  if_charged_free_trial_question: "क्या फ्री ट्रायल में कोई चार्ज लगेगा?",
  if_charged_free_trial_answer:
    "नहीं, क्रेडिट कार्ड केवल सत्यापन के लिए है। जब तक आप अपग्रेड नहीं चुनते, कोई शुल्क नहीं लगेगा।",
  what_happens_after_add_card_question:
    "क्रेडिट कार्ड जोड़ने के बाद क्या होगा?",
  what_happens_after_add_card_answer:
    "पहली रिचार्ज के बाद, आपको टूल टेस्ट करने के लिए तुरंत अतिरिक्त फ्री क्रेडिट्स मिलेंगे - बिना किसी शर्त के!",

  features: "फीचर्स",
  search: "खोज",
  per_page_limits: "प्रति पेज लिमिट",
  total_page_limits: "कुल पेज लिमिट",
  record_upload_limits: "रिकॉर्ड अपलोड लिमिट",
  export_limits: "एक्सपोर्ट लिमिट",
  top_up_credits: "क्रेडिट टॉप-अप",
  record_selections: "रिकॉर्ड चयन",
  company_selection_limit: "कंपनी चयन लिमिट",
  prospect_selection_limit: "प्रॉस्पेक्ट चयन लिमिट",
  portal: "पोर्टल",
  query_limit_per_hour: "प्रति घंटे क्वेरी लिमिट",
  query_limit_per_day: "प्रतिदिन क्वेरी लिमिट",
  query_limit_per_month: "मासिक क्वेरी लिमिट",
  api: "API",
  call_limit_per_hour: "प्रति घंटे API कॉल लिमिट",
  call_limit_per_day: "दैनिक API कॉल लिमिट",
  call_limit_per_month: "मासिक API कॉल लिमिट",

  pricing_plan_compare_all_plans: "सभी प्लान्स की तुलना करें",
  pricing_plan_title: "मूल्य निर्धारण योजना",
  pricing_plan_desc:
    "कोई छुपे हुए शुल्क नहीं, अपनी आवश्यकताओं के अनुरूप प्लान चुनें।",
  save_20: "20% बचत",
  pricing_plan_currency_list: "मुद्रा सूची",
  most_popular: "सबसे लोकप्रिय",
  per_monthly: "मासिक",
  per_annual: "वार्षिक",
  by_monthly: "मासिक बिलिंग",
  by_annual: "वार्षिक बिलिंग",
  pricing_plan_per_cost: "प्रति यूजर प्रति माह - {type}",
  pricing_plan_organization_desc:
    "कस्टम प्लान लचीली फंक्शनैलिटी और क्रेडिट्स प्रदान करते हैं, जो आपकी आवश्यकताओं के अनुरूप डिज़ाइन किए जाते हैं।",
  pricing_plan_credit_info:
    "क्रेडिट्स प्लेटफॉर्म की सामान्य मुद्रा हैं, विशिष्ट एक्शन्स करने पर खर्च होते हैं।",
  exports: "निर्यात",
  get_in_touch: "संपर्क करें",
  get_in_touch_desc: "कस्टम कोटेशन और सहायता के लिए हमसे संपर्क करें",
  pricing_plan_learn_credits: "क्रेडिट्स के बारे में अधिक जानें",
  pricing_plans_primary_button_current: "वर्तमान प्लान",
  pricing_plans_primary_button_free: "मुफ्त ट्रायल शुरू करें",
  pricing_plans_primary_button: "अभी शुरू करें",
  pricing_plans_primary_button_organization: "हमसे संपर्क करें",

  free_feature_1: "300M+ संभावित ग्राहक और कंपनी रिकॉर्ड",
  free_feature_2: "सत्यापित ईमेल और फोन नंबर",
  free_feature_3: "विस्तार सिग्नल — पिछले 90 दिन",

  startup_feature_1: "फ्री की सभी सुविधाएँ",
  startup_feature_2: "पूरा विस्तार इतिहास और हर सिग्नल",
  startup_feature_3: "स्थानीय टीम और सभी बाज़ार",
  startup_feature_4: "API एक्सेस और ऑटोमेशन",

  corporate_feature_1: "Startup की सभी सुविधाएँ",
  corporate_feature_2: "विश्लेषण और पूर्व-निर्मित रिपोर्ट",
  corporate_feature_3: "टीम और कोटा प्रबंधन",
  corporate_feature_4: "उन्नत सुरक्षा और SSO",
  corporate_feature_5: "प्राथमिकता समर्थन",

  organization_feature_1: "Corporate की सभी सुविधाएँ",
  organization_feature_2: "कस्टम सीमाएँ और क्रेडिट",
  organization_feature_3: "समर्पित कस्टमर सक्सेस मैनेजर",
  organization_feature_4: "कस्टम इंटीग्रेशन और SSO",
  organization_feature_5: "SLA और ऑनबोर्डिंग",

  plan_tagline_free: "शुरुआत के लिए",
  plan_tagline_startup: "बढ़ती सेल्स टीमों के लिए",
  plan_tagline_corporate: "स्केल करती सेल्स संस्थाओं के लिए",
  plan_tagline_organization: "एंटरप्राइज़ के लिए",

  pricing_plan_whats_included: "क्या शामिल है",
  pricing_plan_credits_line: "{n} क्रेडिट / माह",

  pricing_section_usage: "उपयोग और सीमाएँ",
  pricing_section_portal: "पोर्टल क्वेरी",
  pricing_section_api: "API",
  pricing_section_access: "एक्सेस और सुरक्षा",
  api_access: "API एक्सेस",

  pricing_section_expansion: "विस्तार इंटेलिजेंस",
  expansion_signal_history: "सिग्नल इतिहास",
  expansion_signals_team: "हर सिग्नल और स्थानीय टीम",
  expansion_employees: "कर्मचारी डेटा (संख्या और लोग)",
  expansion_markets: "विस्तार बाज़ार",
  expansion_full: "पूर्ण",
  expansion_n_days: "{n} दिन",
  expansion_all: "सभी",

  free_feature_title: "फ्री प्लान में शामिल",
  growth_feature_title: "ग्रोथ प्लान में शामिल",
  business_feature_title: "बिजनेस प्लान में शामिल",
  organization_feature_title: "कस्टम प्लान में शामिल",

  sequence_execution: "वर्कफ्लो एक्जीक्यूशन",
  sequence_execution_details:
    "प्रत्येक एक्जीक्यूट की गई एक्शन 0 क्रेडिट खर्च करेगी।| प्रत्येक एक्जीक्यूट की गई एक्शन 1 क्रेडिट खर्च करेगी।| प्रत्येक एक्जीक्यूट की गई एक्शन {0} क्रेडिट खर्च करेगी।",
  ai_translation: "AI अनुवाद",
  ai_translation_details:
    "प्रत्येक AI अनुवाद परिणाम 0 क्रेडिट खर्च करेगा।| प्रत्येक AI अनुवाद परिणाम 1 क्रेडिट खर्च करेगा।| प्रत्येक AI अनुवाद परिणाम {0} क्रेडिट खर्च करेगा।",

  includes: "शामिल",
  pricing_plans_customize_feature_title: "पर्सनलाइज्ड प्लान",
  pricing_plans_customize_feature_desc:
    "हमारी कस्टम सब्सक्रिप्शन सेवा संगठनों को बिजनेस ग्रोथ ड्राइव करने में मदद करने के लिए डिज़ाइन की गई है",
  settings_estimate_subscription: "सदस्यता:",
  settings_estimate_original_price: "मूल मूल्य:",

  permission_profiles: "अनुमति प्रोफाइल",
  team_management: "टीम प्रबंधन",
};
